/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


  // Aria-hidden fix
(function () {
  const FOCUSABLE = 'a, button, input, select, textarea';

  // 1. Brutal force fix for collection-item anchors
  function stripAriaFromCollectionItems() {
    document.querySelectorAll('.collection-item').forEach(el => {
      if (el.tagName === 'A') {
        el.removeAttribute('aria-hidden');
        el.removeAttribute('tabindex');
        el.removeAttribute('aria-disabled');
      }

      el.querySelectorAll(FOCUSABLE).forEach(inner => {
        inner.removeAttribute('aria-hidden');
        inner.removeAttribute('tabindex');
        inner.removeAttribute('aria-disabled');
      });
    });
  }

  // 2. Smart visibility-based fix for .product-item children
  function fixProductItemFocusables() {
    document.querySelectorAll('.product-item').forEach(el => {
      const container =
        el.closest('.flickity-viewport') ||
        el.closest('.scroller__inner, .product-list--scrollable') ||
        document.body;

      const elRect = el.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const visible =
        elRect.left < containerRect.right &&
        elRect.right > containerRect.left &&
        elRect.top < containerRect.bottom &&
        elRect.bottom > containerRect.top;

      el.querySelectorAll(FOCUSABLE).forEach(focusable => {
        if (visible) {
          focusable.removeAttribute('tabindex');
          focusable.removeAttribute('aria-disabled');
          focusable.removeAttribute('aria-hidden');
        } else {
          focusable.setAttribute('tabindex', '-1');
          focusable.setAttribute('aria-disabled', 'true');
          focusable.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  // Unified trigger
  function runAccessibilityFixes() {
    stripAriaFromCollectionItems();   // Always remove broken ARIA
    fixProductItemFocusables();       // Context-aware fix for product cards
  }

  // Run immediately
  runAccessibilityFixes();

  // Watch future DOM mutations
  const observer = new MutationObserver(runAccessibilityFixes);
  observer.observe(document.body, { childList: true, subtree: true });

  // Resize
  window.addEventListener('resize', runAccessibilityFixes);

  // Flickity hook
  document.querySelectorAll('.flickity-enabled').forEach(el => {
    const flkty = window.Flickity?.data?.(el);
    if (flkty) flkty.on('select', runAccessibilityFixes);
  });

  // Expose globally
  window.fixFocusableInCarousels = runAccessibilityFixes;
})();




  // testimonial section
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-section-type="testimonials-slider"]');

  sliders.forEach((slider, index) => {

    const container = slider.querySelector('.testimonial-scroller');
    const prevBtn = slider.querySelector('.testimonial-scroller-button-prev');
    const nextBtn = slider.querySelector('.testimonial-scroller-button-next');

    if (!container || !prevBtn || !nextBtn) return;

    const card = container.querySelector('.testimonial-scroller-card') || container.querySelector('.testimonial-slider-card');
    const gap = 24; // default spacing in px
    const cardWidth = card ? card.offsetWidth + gap : 300;

    // ✅ Scroll to center card (true second card visually)
    requestAnimationFrame(() => {
      container.scrollLeft = cardWidth; // This puts second card in center
    });

    prevBtn.addEventListener('click', () => {
      container.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      container.scrollBy({ left: cardWidth, behavior: 'smooth' });
    });

    // 🧠 Active center card detection
    const updateActiveCard = () => {
      const cards = container.querySelectorAll('.testimonial-scroller-card');
      const containerRect = container.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;

      let closestCard = null;
      let closestDistance = Infinity;

      cards.forEach(card => {
        const cardRect = card.getBoundingClientRect();
        const cardCenter = cardRect.left + cardRect.width / 2;
        const distance = Math.abs(containerCenter - cardCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestCard = card;
        }
      });

      cards.forEach(card => card.classList.remove('active'));
      if (closestCard) closestCard.classList.add('active');
    };

    // 🛰️ Hook into scroll events
    container.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateActiveCard);
    });

    // 🔁 Initial activation on load
    updateActiveCard();

    // 📱 Scroll to first card on mobile
    if (window.innerWidth <= 767) {
      container.scrollTo({ left: 0, behavior: 'auto' });
    }

    // 🧠 Expand/collapse long quotes
    const toggleButtons = slider.querySelectorAll('.quote-toggle');

    toggleButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const quote = btn.previousElementSibling;

        if (quote.classList.contains('expanded')) {
          quote.classList.remove('expanded');
          btn.textContent = 'Read more';
        } else {
          quote.classList.add('expanded');
          btn.textContent = 'Collapse';
        }
      });
    });

  });
});

  // Qty reset

(() => {
  const DEBUG_MODE = false; // 🛠️ Toggle to false to disable logs

  const log = (...args) => {
    if (DEBUG_MODE) console.log(...args);
  };
  
  document.addEventListener("change", (event) => {
    const target = event.target;
    if (!target.matches('input[type="radio"][name="option1"]')) return;

    const inputs = Array.from(document.querySelectorAll('input[type="radio"][name="option1"]'));
    const selectedIndex = inputs.findIndex(input => input.checked);

    log(`🥷 📡 Detected change on option1 → Index: ${selectedIndex}`);

    if (selectedIndex === 0) {
      const qtyInput = document.querySelector('.quantity-selector__value');
      if (qtyInput) {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        log('🔁 Qty reset to 1 (No Case selected)');
      }
    }
  });

  log("🛡️ Qty auto-reset script initialized");
})();

  // spin studio 360
document.addEventListener('DOMContentLoaded', function () {
  const spinStudioSelectors = [
    'img[src*="spinstudio.myshopify.com"]',
    'img[id*="spin-studio"]',
    'img[class*="spin-studio"]'
  ].join(',');

  function handleSpinStudioAltText() {
    const images = document.querySelectorAll(spinStudioSelectors);

    images.forEach(img => {
      const src = img.getAttribute('src')?.trim() || '';
      const isVisible = img.offsetParent !== null;

      // If alt already set, leave it alone
      if (img.hasAttribute('alt')) return;

      if (src.includes('spinstudio.myshopify.com') && isVisible && src !== '') {
        img.alt = 'Spin Studio 360 Product Image';
      } else {
        img.alt = ''; // Decorative fallback
      }
    });
  }

  // 🔁 Initial run
  handleSpinStudioAltText();

  // 🔍 DOM Watcher
  const observer = new MutationObserver(() => {
    handleSpinStudioAltText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'alt']
  });
});







